module.exports = __webpack_public_path__ + "static/hard-drive-419057f448da9f1029bf713911e76afa.jpg";